import { QUOTE_STATUSES } from "./quoteStatuses";

export const QUOTE_STATUS_TEXT_MAP = {
  [QUOTE_STATUSES.REJECTED_NOT_TAKEN_UP]: "Not taken up",
};

export default QUOTE_STATUS_TEXT_MAP;
